import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, IconButton, Chip, Button, Card, Divider, Drawer } from '@material-ui/core';
import Lightbox from 'react-image-lightbox';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper';
import 'swiper/css';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { TrashIcon } from 'asterX-UI/Icons';
import { EditIcon } from 'asterX-UI/Icons/EditIcon';
import SmsOutlinedIcon from '@material-ui/icons/SmsOutlined';
import CommentWall from 'pages/AdminPage/comments/CommentWall';
import { setLikes, removeLike } from 'requests/likesApi';
import { memo } from 'react';
import jwtDecode from 'jwt-decode';
import { useEffect } from 'react';
import { InfoModal } from 'asterX-UI/Modals';
import { LoaderBackdrop } from 'asterX-UI/Loaders';
import { useRoutes } from 'hooks';
import { ADMIN_PATH } from 'routes/constants.routes';
import { useHistory } from 'react-router';
import { purpleB } from 'constants/colors';
import moment from 'moment';
import { useRef } from 'react';
import Linkify from 'react-linkify';
const useStyles = makeStyles((theme) => ({
  card: {
    border: '1px solid #edeef0',
    padding: 20,
    borderRadius: 10,
    maxWidth: '700px',
    margin: '0 auto 15px auto',
    display: 'flex',
    flexDirection: 'column',
  },
  container: { margin: 'auto', maxWidth: '600px', marginBottom: theme.spacing(10) },
  slider: {
    position: 'relative',
    overflow: 'hidden',
    maxWidth: '100%',
  },
  img: {
    width: '100%',
    height: 'auto',
    marginTop: '30px',
    marginBottom: '30px',
    borderRadius: '5px',
  },
  video: {
    width: '100%',
    height: '400px',
    marginTop: '30px',
    marginBottom: '30px',
    borderRadius: '5px',
  },
  actionBar: {
    display: 'flex',
    marginTop: '20px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  marginRight: {
    marginRight: '10px',
  },
  arrowStyles: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '14px',
    zIndex: '10',
    backgroundColor: '#F9F5FF',
    color: '#7F56D9',
    opacity: '0.6',
    '&:hover': {
      color: '#F9F5FF',
      backgroundColor: '#7F56D9',
    },
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
  },
  drawerPaper: {
    width: '100%',
    overflowX: 'hidden',
    zIndex: '998 !important',
  },
  root: {
    zIndex: '998 !important',
    '& .MuiBackdrop-root': {
      backdropFilter: 'blur(16px)',
      transition: 'none !important',
      backgroundColor: 'rgba(0, 0, 0, 0.6) !important',
    },
  },
}));

const NewsItem = ({ id, title, text, thumbnail, videoLink, createdDate, categoryCode, likes, comments, commentsAllowed, ...props }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);
  const [likeCount, setLikeCount] = useState(0);
  const [liked, setLiked] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [commentCount, setCommentCount] = useState(comments?.length || 0);
  const classes = useStyles();
  const [CW, setCW] = useState(document.documentElement.clientWidth);
  const [openDrawer, setOpenDrawer] = useState(false);

  const history = useHistory();
  const { onDelete } = props;
  const cardRef = useRef(null);

  window.onresize = () => {
    setCW(document.documentElement.clientWidth);
  };

  const currentUser = jwtDecode(localStorage.getItem('access_token'));

  const userRole = currentUser.roleList.find((f) => f.project.code === 'NEWS');
  const isAdmin = userRole?.code === 'ADMIN';

  useEffect(() => {
    setLiked(!!likes.find((like) => like.createdBy === currentUser.sub));
    setLikeCount(likes.length);
  }, []);

  const handlePrevSlide = () => {
    if (thumbsSwiper) {
      thumbsSwiper.slidePrev();
    }
  };

  const handleNextSlide = () => {
    if (thumbsSwiper) {
      thumbsSwiper.slideNext();
    }
  };

  const handleChangeLike = () => {
    if (!liked) {
      setLikeCount(likeCount + 1);
      setLikes(id);
      setLiked(true);
    } else {
      setLikeCount(likeCount - 1);
      removeLike(id);
      setLiked(false);
    }
  };

  const handleClickComment = () => {
    setOpenDrawer(true);
  };

  const handleOpenModal = async (id) => {
    setIsModalOpen(true);
  };
  const handleTextExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleNews = (id) => {
    history.push(ADMIN_PATH + '/' + id);
  };

  const handleDelete = async (id) => {
    try {
      onDelete(id);
      setIsModalOpen(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Card ref={cardRef} className={classes.card}>
      {CW < 768 && (
        <Drawer
          anchor={'left'}
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          classes={{
            paper: classes.drawerPaper,
            root: classes.root,
          }}
        >
          <Box style={{ width: '100%' }}>
            <Button onClick={() => setOpenDrawer(false)}>
              <ArrowBackIosRoundedIcon />
              <Typography variant='h6' style={{ fontSize: '20px' }}>
                Комментарии
              </Typography>
            </Button>
            <Divider />
          </Box>
          <CommentWall id={id} CW={CW} setCommentCount={setCommentCount} />
        </Drawer>
      )}

      {isLightBoxOpen && (
        <Lightbox
          mainSrc={thumbnail[slideIndex]}
          nextSrc={thumbnail[(slideIndex + 1) % thumbnail.length]}
          prevSrc={thumbnail[(slideIndex + thumbnail.length - 1) % thumbnail.length]}
          onCloseRequest={() => setIsLightBoxOpen(false)}
          onMovePrevRequest={() => setSlideIndex((slideIndex - 1 + thumbnail.length) % thumbnail.length)}
          onMoveNextRequest={() => setSlideIndex((slideIndex + 1) % thumbnail.length)}
        />
      )}

      <LoaderBackdrop loading={!!isLoading} />

      <Box>
        {thumbnail && (
          <Box className={classes.slider}>
            <Swiper
              fullWidth
              spaceBetween={10}
              navigation={{ nextEl: '.slider-btn-next', prevEl: '.slider-btn-prev' }}
              thumbs={{ swiper: thumbsSwiper }}
              modules={[FreeMode, Navigation, Thumbs]}
            >
              {' '}
              {thumbnail.map((photo, i) => {
                return (
                  <SwiperSlide key={photo + i} style={{ cursor: 'pointer' }} onClick={() => setIsLightBoxOpen(true)}>
                    {photo?.includes('youtube') ? (
                      <iframe
                        className={classes.video}
                        src={photo}
                        title='YouTube video player'
                        frameborder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                        allowfullscreen
                      ></iframe>
                    ) : (
                      <img src={photo} width='600' height='340' alt={title} className={classes.img} />
                    )}
                    {/* <img src={photo} width='600' height='340' alt={title} className={classes.img} /> */}
                  </SwiperSlide>
                );
              })}
              <IconButton className={`${classes.arrowStyles} slider-btn-prev`} style={{ left: '10px', display: thumbnail.length === 1 && 'none' }} onClick={handlePrevSlide}>
                <ArrowBackIosRoundedIcon style={{ fontSize: 'inherit' }} />
              </IconButton>
              <IconButton className={`${classes.arrowStyles} slider-btn-next`} style={{ right: '10px', display: thumbnail.length === 1 && 'none' }} onClick={handleNextSlide}>
                <ArrowBackIosRoundedIcon style={{ fontSize: 'inherit', transform: 'rotate(180deg)' }} />
              </IconButton>
            </Swiper>
          </Box>
        )}
      </Box>

      <Box>
        <Typography variant='h6' style={{ fontSize: '20px', fontWeight: '600', lineHeight: '25px', marginBottom: '20px' }}>
          {title}
        </Typography>
      </Box>

      <Box>
        <Linkify
          componentDecorator={(decoratedHref, decoratedText, key) => (
            <a href={decoratedHref} target='_blank' key={key}>
              {decoratedText}
            </a>
          )}
        >
          <Typography style={{ maxHeight: isExpanded ? 'none' : '11.5rem', overflow: 'hidden', fontSize: '17px', lineHeight: '26px', whiteSpace: 'pre-line' }}>{text}</Typography>
        </Linkify>
        {text.length > 200 && !isExpanded && (
          <Typography variant='body2' onClick={handleTextExpand} color={'primary'} style={{ cursor: 'pointer', fontSize: '17px' }}>
            Показать все
          </Typography>
        )}
        {text.length > 100 && isExpanded && (
          <Typography variant='body2' onClick={handleTextExpand} color={'primary'} style={{ cursor: 'pointer', fontSize: '17px' }}>
            Скрыть
          </Typography>
        )}
      </Box>

      <Box className={classes.actionBar}>
        <Box>
          <Chip
            avatar={<FavoriteIcon style={{ color: liked ? 'red' : 'grey', paddingLeft: '3px' }} />}
            label={likeCount}
            style={{ background: liked && 'pink' }}
            className={classes.marginRight}
            onClick={handleChangeLike}
            clickable
          />
          {commentsAllowed && <Chip avatar={<SmsOutlinedIcon style={{ color: 'grey', paddingLeft: '3px' }} />} label={commentCount} clickable onClick={handleClickComment} />}
        </Box>
        {isAdmin && (
          <Box>
            <EditIcon style={{ marginRight: '30px', cursor: 'pointer' }} onClick={() => handleNews(id)} />
            <TrashIcon style={{ cursor: 'pointer' }} onClick={handleOpenModal} />
          </Box>
        )}
      </Box>

      <Box style={{ marginTop: 10 }}>
        <Typography variant='caption' style={{ color: '#888', fontWeight: 700, marginRight: 4 }}>
          {moment(createdDate).format('HH:mm')}
        </Typography>
        <Typography variant='caption' style={{ color: '#aaa', fontWeight: 500, marginLeft: 4 }}>
          {moment(createdDate).format('DD MMMM YYYY')}
        </Typography>
      </Box>
      {commentsAllowed && CW > 768 && <Divider style={{ marginTop: '20px' }} />}

      <Box>{CW > 768 && commentsAllowed && <CommentWall id={id} CW={CW} cardHeight={cardRef} setCommentCount={setCommentCount}></CommentWall>}</Box>

      <InfoModal open={isModalOpen} onClose={() => setIsModalOpen(false)} isButtonHidden>
        <Box className={classes.modal}>
          <Box>
            <TrashIcon style={{ color: 'red', alignText: 'center' }} />
          </Box>
          <Box>
            <Typography variant='h6' style={{ color: 'black' }}>
              Удалить пост
            </Typography>
          </Box>
          <Box>
            <Typography style={{ color: 'black' }}>Вы уверены, что хотите удалить эту запись? Это действие не может быть отменено.</Typography>
          </Box>

          <Button variant={'outlined'} fullWidth style={{ background: 'red', color: '#fff', marginTop: '30px', marginBottom: '20px' }} onClick={() => handleDelete(id)}>
            Удалить
          </Button>
          <Button variant={'outlined'} fullWidth onClick={() => setIsModalOpen(false)}>
            Отмена
          </Button>
        </Box>
      </InfoModal>
    </Card>
  );
};

export default memo(NewsItem);
